export default function QuotationSummaryCard({
  gstAmount,
  deliveryCharge = 0,
  grandTotal,
}) {
  return (
    <div className="w-full bg-gradient-to-r from-[#2C4BB8] via-[#3567D6] to-[#4B83F0] px-8 py-1 text-white shadow-sm">
      <div className="flex justify-end">
        <div className="text-right">
          <p className="text-sm font-semibold">
            GST Amount : ₹ {gstAmount.toFixed(2)}
          </p>

          {Number(deliveryCharge) > 0 && (
            <p className="mt-1 text-sm font-semibold">
              Delivery Charge : ₹ {Number(deliveryCharge).toFixed(2)}
            </p>
          )}

          <p className="mt-1 text-sm font-bold">
            Grand Total : ₹ {grandTotal.toFixed(2)}
          </p>
        </div>
      </div>
    </div>
  )
}
